import { ColDef, GridOptions } from "ag-grid-community";
import { HeaderWithTooltip } from "~/pages/Compliance/Common/HeaderWithTooltip";
import { PI_GRID_COLUMNS, SCREENING_TOOLTIP } from "../constants";
import { BeneficiaryDetails } from "../types";
import { BeneficiaryCellRenderer, getBeneficiaryCellStyle } from "./BeneficiaryCellRenderer";
import { getScreeningCellStyle, ScreeningCellRenderer } from "./ScreeningCellRenderer";

export const defaultColDef: ColDef = {
  sortable: false,
  filter: false,
  resizable: true,
  cellStyle: { display: "flex", alignItems: "center" },
};

export const gridOptions: GridOptions = {
  rowHeight: 42,
  headerHeight: 42,
  suppressCellFocus: true,
  suppressRowHoverHighlight: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  domLayout: "autoHeight",
};

export const columnDefinition: ColDef<BeneficiaryDetails>[] = [
  {
    headerName: PI_GRID_COLUMNS.BENEFICIARY,
    field: "paymentBeneficiary",
    cellRenderer: BeneficiaryCellRenderer,
    cellClass: (params) => {
      return getBeneficiaryCellStyle(params.data?.paymentBeneficiary, params.data?.readonly);
    },
  },
  {
    headerName: PI_GRID_COLUMNS.SCREENING,
    field: "screening",
    cellRenderer: ScreeningCellRenderer,
    cellClass: (params) => {
      return getScreeningCellStyle(params.data?.screening?.screeningRecord);
    },
    headerComponent: HeaderWithTooltip,
    headerComponentParams: {
      displayName: PI_GRID_COLUMNS.SCREENING,
      tooltipContent: SCREENING_TOOLTIP,
      enableSorting: false,
    },
  },
];
